module.exports = __webpack_public_path__ + "icomoon.6aec335435870a876b67.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/IcoMoon/icomoon.svg?87n1v6
// module id = 392
// module chunks = 5